import React, { useRef } from 'react';
import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function Switch({
  labelChecked,
  labelUnChecked,
  ...props
}: SwitchProps & { labelChecked?: string; labelUnChecked?: string }) {
  const switchRef = useRef<HTMLInputElement>(null);

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      {labelUnChecked && (
        <Typography
          onClick={() => {
            switchRef.current?.checked && switchRef.current.click();
          }}
          sx={{
            cursor: 'pointer',
            pointerEvents: props.disabled ? 'none' : 'auto',
          }}
          variant="body2"
        >
          {labelUnChecked}
        </Typography>
      )}
      <MuiSwitch
        {...props}
        disableRipple
        focusVisibleClassName=".Mui-focusVisible"
        inputRef={switchRef}
      />
      {labelChecked && (
        <Typography
          color={
            switchRef.current?.checked && !props.disabled
              ? (theme) =>
                  props.color && props.color !== 'default'
                    ? theme.palette[props.color].main
                    : theme.palette.primary.main
              : undefined
          }
          onClick={() => {
            !switchRef.current?.checked && switchRef.current?.click();
          }}
          sx={{
            cursor: 'pointer',
            pointerEvents: props.disabled ? 'none' : 'auto',
          }}
          variant="body2"
        >
          {labelChecked}
        </Typography>
      )}
    </Stack>
  );
}
